import '.al{flex:1;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.b5{align-items:start;}.ssr-plugin'
import '.bk{gap:8px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a1{gap:4px;}.ssr-plugin'
import { ReactNode } from 'react'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { Icon } from '../Icon/index.js'
import { Note, NoteProps } from '../Note/index.js'
import { styled } from 'inlines'

type FormFieldProps = {
  label?: string
  description?: string
  error?: string
  children: ReactNode
  note?: Pick<NoteProps, 'title' | 'description'>
}

function FormField({
  children,
  label,
  description,
  error,
  note,
}: FormFieldProps) {
  return (
    <div className="al f a ac b5 bk"
    >
      {label && (
        <Text variant="subtext-regular" color="neutral60">
          {label}
        </Text>
      )}
      <div className="f">{children}</div>

      {error && (
        <div className="a d a1"
          style={{
            color: colors.red100,
          }}
        >
          <Icon variant="error-filled" color="red100" />
          <Text color="inherit" variant="display-medium">
            {error}
          </Text>
        </div>
      )}
      {description && (
        <Text variant="display-regular" color="neutral60">
          {description}
        </Text>
      )}
      {note && <Note {...note} />}
    </div>
  )
}

export { FormField }
export type { FormFieldProps }
